export class ApplicationNames {
    public static readonly APPLICATION_NAME = "I-DS/PC-MS";
    private static readonly currentYear = new Date().getFullYear();
    public static readonly COPYRIGHT = `© ${ApplicationNames.currentYear} OOO «ИндаСофт»`;
}